"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7750],{

/***/ 37750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ErrorPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(67107);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/result/result.tsx



var adornment = function(value) {
    if (typeof value === "string" || typeof value === "number") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            color: "primary",
            className: "text-4xl font-extrabold sm:text-5xl",
            children: value
        });
    }
    return value;
};
var title = function(value) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "h2",
        className: "text-2xl font-bold tracking-tight sm:text-3xl",
        children: value
    });
};
var message = function(value) {
    var isString = typeof value === "string";
    if (isString) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            className: "mt-1 text-base text-gray-500",
            dangerouslySetInnerHTML: {
                __html: value
            }
        });
    }
    return value;
};
function Result(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "sm:flex",
        children: [
            props.adornment && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:border-r sm:border-gray-200 sm:pr-6 sm:mr-6",
                children: adornment(props.adornment)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: props.center ? "text-center" : "",
                children: [
                    title(props.title),
                    message(props.message)
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
;// CONCATENATED MODULE: ./src/components/ErrorPage.tsx




var messages = (0,lib/* defineMessages */.vU)({
    notFound: {
        defaultMessage: "The page you are looking for isn’t here",
        id: "uy5741"
    },
    authorization: {
        defaultMessage: "Authorization required",
        id: "YE+GBJ"
    },
    internal: {
        defaultMessage: "Internal Server Error",
        id: "cTD1CD"
    }
});
var ErrorPage = function(props) {
    var ref, ref1, ref2;
    var intl = (0,useIntl/* default */.Z)();
    var isNotFoundError = ((ref = props.statusCode) === null || ref === void 0 ? void 0 : ref.toString()) === "404";
    var isAuthorizationError = (ref2 = (ref1 = props.statusCode) === null || ref1 === void 0 ? void 0 : ref1.toString()) === null || ref2 === void 0 ? void 0 : ref2.startsWith("4");
    var errorTitle = props.title ? props.title : isNotFoundError ? intl.formatMessage(messages.notFound) : isAuthorizationError ? intl.formatMessage(messages.authorization) : intl.formatMessage(messages.internal);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Error: ",
                        errorTitle
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white min-h-screen px-4 py-16 sm:px-6 sm:py-24 grid place-items-center lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-2xl w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Result, {
                        adornment: props.statusCode,
                        title: errorTitle,
                        message: props.message
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_ErrorPage = (ErrorPage);


/***/ })

}]);